interface CookTimeType {
  label: string
  start?: number
  end?: number
}

const searchFilterCookTimeConfig: CookTimeType[] = [
  { label: 'All' },
  { start: 10, end: 15, label: '10-15 mins' },
  { start: 15, end: 25, label: '15-25 mins' },
  { start: 25, end: 35, label: '25-35 mins' },
  { start: 35, end: 45, label: '35-45 mins' },
  { start: 45, label: '45+ mins' },
]

export default searchFilterCookTimeConfig
